export default __webpack_public_path__ + "static/media/image.budget-home-management.fda32445.png";